import * as React from 'react'
import type {
  DiscountQuote,
  JoinApplicationResponse,
  JoinCustomFieldValue,
  JoinFormErrors,
  OrganizationForm,
  PersonFieldName,
  PersonForm,
  PublicJoinCustomField,
  WizardStep,
} from '@/pages/PublicJoinFormPage.types'

export function usePublicJoinFormState() {
  const [step, setStep] = React.useState<WizardStep>('apply')
  const [selectedLevelId, setSelectedLevelId] = React.useState<number | null>(null)
  const [person, setPerson] = React.useState<PersonForm>({ name: '', email: '', phone: '' })
  const [organization, setOrganization] = React.useState<OrganizationForm>({
    name: '',
    email: '',
    phone: '',
  })
  const [website, setWebsite] = React.useState('')
  const [customFieldValues, setCustomFieldValues] = React.useState<
    Record<string, JoinCustomFieldValue>
  >({})
  const [errors, setErrors] = React.useState<JoinFormErrors>(() => emptyErrors())
  const [submission, setSubmission] = React.useState<JoinApplicationResponse | null>(null)
  const [discountCode, setDiscountCode] = React.useState('')
  const [discountQuote, setDiscountQuote] = React.useState<DiscountQuote | null>(null)
  const [enrollAutopay, setEnrollAutopay] = React.useState(false)
  const [selectedChapterIds, setSelectedChapterIds] = React.useState<number[]>([])

  function updatePersonField(name: PersonFieldName, value: string) {
    setPerson((current) => ({ ...current, [name]: value }))
    setErrors((current) => ({ ...current, person: { ...current.person, [name]: undefined } }))
  }
  function updateOrganizationField(name: PersonFieldName, value: string) {
    setOrganization((current) => ({ ...current, [name]: value }))
    setErrors((current) => ({
      ...current,
      organization: { ...current.organization, [name]: undefined },
    }))
  }
  function updateCustomField(field: PublicJoinCustomField, value: JoinCustomFieldValue) {
    const key = String(field.id)
    setCustomFieldValues((current) => ({ ...current, [key]: value }))
    setErrors((current) => {
      const nextCustomErrors = { ...current.customFields }
      delete nextCustomErrors[key]
      return { ...current, customFields: nextCustomErrors }
    })
  }

  return {
    step,
    setStep,
    selectedLevelId,
    setSelectedLevelId,
    person,
    organization,
    website,
    setWebsite,
    customFieldValues,
    errors,
    setErrors,
    submission,
    setSubmission,
    discountCode,
    setDiscountCode,
    discountQuote,
    setDiscountQuote,
    enrollAutopay,
    setEnrollAutopay,
    selectedChapterIds,
    setSelectedChapterIds,
    updatePersonField,
    updateOrganizationField,
    updateCustomField,
  }
}

function emptyErrors(): JoinFormErrors {
  return { person: {}, organization: {}, customFields: {} }
}
